export enum MeritCompensationVisibilityLevel {
  Employee = 'Employee',
  HrBusinessPartner = 'HrBusinessPartner',
  Admin = 'Admin'
}
